'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.nodeContextWidget = function (mapModel) {
	return mmWidgets.each(this, function () {
		const element = this,
			updateForContext = function (context) {
				const shouldDisable = function (domElement) {
					const attrValue = domElement.getAttribute('data-mm-node-context'),
						invert = attrValue[0] === '!',
						expectedValue = invert ? attrValue.slice(1) : attrValue,
						result = !context || !context[expectedValue];
					return invert ? (!result) : result;
				};
				element.domElements.forEach(function (domElement) {
					if (shouldDisable(domElement)) {
						domElement.classList.add('disabled');
					} else {
						domElement.classList.remove('disabled');
					}
				});
			};
		mapModel.addEventListener('layoutChangeComplete', function () {
			const id = mapModel.getSelectedNodeId();
			updateForContext(mapModel.contextForNode(id));
		});
		mapModel.addEventListener('nodeSelectionChanged', function (id, isSelected) {
			if (isSelected) {
				updateForContext(mapModel.contextForNode(id));
			}
		});
	});
};
